import { defineStore } from "pinia";
import { ref } from "vue";

export const useEstadoCivilStore = defineStore("estadoCivil", () => {
  const estadoCivil = ref([
    { id: "2", nombre: "Casado/a" },
    { id: "4", nombre: "Divorciado/a" },
    { id: "3", nombre: "Separado/a" },
    { id: "1", nombre: "Soltero/a" },
    { id: "5", nombre: "Viudo/a" },
  ]);

  const getAll = () => estadoCivil.value;

  const getByNombre = (nombre) => {
    if (!nombre) return null;

    const estadoCivilFounded = estadoCivil.value.find(
      (n) => n.nombre.toUpperCase() === nombre.toUpperCase()
    );

    return estadoCivilFounded ? estadoCivilFounded.id : null;
  };

  return {
    estadoCivil,
    getAll,
    getByNombre,
  };
});
